export default __webpack_public_path__ + "static/media/syna-400.852a903a.jpg";